import type { ProtocolEdgeType } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SetDraggedProtocolCommand {
  protocol: ProtocolEdgeType | null;
}

export const setDraggedProtocol: GraphCommandFactory<
  SetDraggedProtocolCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.layoutSettings.draggedProtocol = command.protocol;
  });
};
